// extracted by mini-css-extract-plugin
export default {"folderScopeContainer":"FxvGH","folderNameChevron":"Q6GTf","folderName":"mPpV5","label":"FToxc","folderOptions":"se4xV"};